document.addEventListener("DOMContentLoaded", function () {
    if (typeof ubigeoData === 'undefined') {
        console.error('ubigeo_data.js not loaded properly.');
        return;
    }

    console.log('ubigeoData:', ubigeoData);  // Debugging: check if data is loaded

    const departmentSelect = document.getElementById('cart-department');
    const provinceSelect = document.getElementById('cart-province');
    const districtSelect = document.getElementById('cart-district');
    const ubigeoInput = document.getElementById('cart-ubigeo');

    // Helper function to populate the select options
    function populateSelect(selectElement, items, placeholder, selectedValue) {
        selectElement.innerHTML = `<option value="">${placeholder}</option>`;
        items.forEach(item => {
            const option = document.createElement('option');
            option.value = item;
            option.textContent = item;
            if (selectedValue && selectedValue === item) {
                option.selected = true;
            }
            selectElement.appendChild(option);
        });
    }

    // Get unique departments from the data
    const departments = [...new Set(ubigeoData.map(item => item.Departamento))];
    console.log('Departments:', departments);  // Debugging: check if departments are extracted

    // Shopify Liquid variables: pre-select options if the cart has them
    const preSelectedDepartment = "{{ cart.attributes['Departamento'] }}";
    const preSelectedProvince = "{{ cart.attributes['Provincia'] }}";
    const preSelectedDistrict = "{{ cart.attributes['Distrito'] }}";
    const preSelectedUbigeo = "{{ cart.attributes['Ubigeo'] }}";

    // Populate departments with pre-selected value
    if (departments.length > 0) {
        populateSelect(departmentSelect, departments, "Departamento", preSelectedDepartment);
        console.log('Populated department select box');  // Debugging: confirm population
    } else {
        console.error('No departments found to populate.');
    }

    if (preSelectedDepartment) {
        const provinces = [...new Set(ubigeoData
            .filter(item => item.Departamento === preSelectedDepartment)
            .map(item => item.Provincia))];
        populateSelect(provinceSelect, provinces, "Provincia", preSelectedProvince);
        provinceSelect.disabled = false;
    }

    if (preSelectedProvince) {
        const districts = [...new Set(ubigeoData
            .filter(item => item.Departamento === preSelectedDepartment && item.Provincia === preSelectedProvince)
            .map(item => item.Distrito))];
        populateSelect(districtSelect, districts, "Distrito", preSelectedDistrict);
        districtSelect.disabled = false;
    }

    // On department change
    departmentSelect.addEventListener('change', function () {
        const selectedDepartment = this.value;

        // Reset province and district select boxes
        provinceSelect.disabled = true;
        districtSelect.disabled = true;
        populateSelect(provinceSelect, [], "Seleccionar Provincia");
        populateSelect(districtSelect, [], "Seleccionar Distrito");
        ubigeoInput.value = "";

        if (selectedDepartment) {
            // Filter provinces based on selected department
            const provinces = [...new Set(ubigeoData
                .filter(item => item.Departamento === selectedDepartment)
                .map(item => item.Provincia))];
            populateSelect(provinceSelect, provinces, "Seleccionar Provincia");
            provinceSelect.disabled = false;
        }
    });

    // On province change
    provinceSelect.addEventListener('change', function () {
        const selectedProvince = this.value;
        const selectedDepartment = departmentSelect.value;

        // Reset district select box
        districtSelect.disabled = true;
        populateSelect(districtSelect, [], "Seleccionar Distrito");
        ubigeoInput.value = "";

        if (selectedProvince) {
            // Filter districts based on selected department and province
            const districts = [...new Set(ubigeoData
                .filter(item => item.Departamento === selectedDepartment && item.Provincia === selectedProvince)
                .map(item => item.Distrito))];
            populateSelect(districtSelect, districts, "Seleccionar Distrito");
            districtSelect.disabled = false;
        }
    });

    // On district change
    districtSelect.addEventListener('change', function () {
        const selectedDistrict = this.value;
        const selectedProvince = provinceSelect.value;
        const selectedDepartment = departmentSelect.value;

        if (selectedDistrict) {
            // Find the ubigeo based on selected department, province, and district
            const ubigeo = ubigeoData.find(item =>
                item.Departamento === selectedDepartment &&
                item.Provincia === selectedProvince &&
                item.Distrito === selectedDistrict
            ).Ubigeo;
            ubigeoInput.value = ubigeo;
        } else {
            ubigeoInput.value = "";
        }
    });
});
